import { render, staticRenderFns } from "./movement-form.vue?vue&type=template&id=7b5cc08c&"
import script from "./movement-form.vue?vue&type=script&lang=js&"
export * from "./movement-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports